import { useTranslation } from 'react-i18next'
import { QRCode } from 'react-qr-code'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { WalletModelShort } from '@root/entities/wallet/ui'
import { Drawer, ShareArrowIcon } from '@root/shared/ui-kit'

import { WalletAddress } from '../common/wallet-address'

import type { WalletModel } from '@root/entities/wallet/atoms'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = { wallet: WalletModel } & Pick<
  DrawerProps,
  'onOpenChange' | 'open'
>

export const WalletDepositDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  wallet,
}) => {
  const { t } = useTranslation()

  const handleShare = () => {
    navigator.share({
      text: wallet.address,
    })
  }

  return (
    <Root open={open} onOpenChange={onOpenChange} title={t('deposit')}>
      <Content>
        <WalletModelShort size="sm" wallet={wallet} />
        <QrCodeContainer>
          <QrCodeStyled
            size={240}
            value={wallet.address}
            bgColor="var(--background-2)"
            fgColor="var(--text-12)"
          />
        </QrCodeContainer>
        <WalletAddress address={wallet.address} />
        <ButtonShare
          radius="rounded"
          onClick={handleShare}
          size="m"
          iconLeft={<ShareArrowIcon />}
          color="primary"
          fullWidth
        >
          {t('common.share')}
        </ButtonShare>
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)``
const Content = styled.div`
  padding-block: 8px 38px;
  padding-inline: 12px;

  display: grid;
  justify-items: center;
`

const QrCodeContainer = styled.div`
  border-radius: 18px;
  display: grid;
  display: grid;
  justify-items: center;
  align-items: center;

  border: 1px solid var(--backgroundA-3);

  padding: 6px;
  justify-items: center;
  margin: 12px 0 16px;
`

const QrCodeStyled = styled(QRCode)`
  border-radius: 12px;
`

const ButtonShare = styled(Button)`
  margin-top: 40px;
`
